const BPMIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    color="inherit"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.66667 18.6667L11.3333 13.6667L6 13L14 5.33333H15.3333L12.6667 10.3333L18 11L10 18.6667H8.66667ZM12.3667 14.55L15.05 11.9833L10.5667 11.4167L11.6167 9.46667L8.95 12.0333L13.4167 12.5833L12.3667 14.55Z" />
  </svg>
);

export default BPMIcon;
